module.exports = __webpack_public_path__ + "img/CHAdeMO@3x.55a5ac24.png";